import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {Container, ContentDescriptions, TextBold, Text, IconWrapper} from "./styled";
import React from "react";
import {PaymentSubscriptionEntity} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_entity";
import {formatCurrency} from "@dropDesk/utils/helpers/common";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";


const CurrentSubscription = (
    {
        currentSubscription
    }: {
        currentSubscription: PaymentSubscriptionEntity
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <Container>
            <TextBold size={17} color={colors.text}>Plano Atual:</TextBold>

            <ContentDescriptions>
                <IconWrapper>
                    <DropDeskIcon icon={ICONS_DROPDESK.subscription} size={15} color={colors.hintInverse}/>
                    <Text color={colors.text} size={15}>{currentSubscription.planName}</Text>
                </IconWrapper>
                <Text color={colors.text} size={15}>{formatCurrency(currentSubscription.planValue())}</Text>
            </ContentDescriptions>
        </Container>
    );
}
export default CurrentSubscription;
